import { render, staticRenderFns } from "./item-wrap.vue?vue&type=template&id=21aa009b&scoped=true"
import script from "./item-wrap.vue?vue&type=script&lang=js"
export * from "./item-wrap.vue?vue&type=script&lang=js"
import style0 from "./item-wrap.vue?vue&type=style&index=0&id=21aa009b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa009b",
  null
  
)

export default component.exports